module.exports = __webpack_public_path__ + "img/house-1@2x.dcfef707.jpg";